import React from 'react';
import classes from './HorizontalSpace.module.scss';

export function HorizontalSpace() {
  return <span className={classes.root} />;
}
